<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M2.25 5C2.25 3.48119 3.48119 2.25 5 2.25C6.51881 2.25 7.75 3.48119 7.75 5V6.25H12.25V5C12.25 3.48119 13.4812 2.25 15 2.25C16.5188 2.25 17.75 3.48119 17.75 5C17.75 6.51881 16.5188 7.75 15 7.75H13.75V12.25H15C16.5188 12.25 17.75 13.4812 17.75 15C17.75 16.5188 16.5188 17.75 15 17.75C13.4812 17.75 12.25 16.5188 12.25 15V13.75H7.75V15C7.75 16.5188 6.51881 17.75 5 17.75C3.48119 17.75 2.25 16.5188 2.25 15C2.25 13.4812 3.48119 12.25 5 12.25H6.25V7.75H5C3.48119 7.75 2.25 6.51881 2.25 5ZM5 3.75C4.30961 3.75 3.75 4.30961 3.75 5C3.75 5.69039 4.30961 6.25 5 6.25H6.25V5C6.25 4.30961 5.69039 3.75 5 3.75ZM7.75 7.75V12.25H12.25V7.75H7.75ZM13.75 5C13.75 4.30961 14.3096 3.75 15 3.75C15.6904 3.75 16.25 4.30961 16.25 5C16.25 5.69039 15.6904 6.25 15 6.25H13.75V5ZM5 13.75C4.30961 13.75 3.75 14.3096 3.75 15C3.75 15.6904 4.30961 16.25 5 16.25C5.69039 16.25 6.25 15.6904 6.25 15V13.75H5ZM13.75 15V13.75H15C15.6904 13.75 16.25 14.3096 16.25 15C16.25 15.6904 15.6904 16.25 15 16.25C14.3096 16.25 13.75 15.6904 13.75 15Z"
            fill="currentColor"
        />
    </svg>
</template>
